import {
  ALL_CIR_REQUEST,
  ALL_CIR_SUCCESS,
  ALL_CIR_FAILURE,
  ALL_CIR_LOOKUPS_REQUEST,
  ALL_CIR_LOOKUPS_SUCCESS,
  ALL_CIR_LOOKUPS_FAILURE,
  CIR_REQUEST,
  CIR_SUCCESS,
  CIR_FAILURE,
  CIR_SAVE_REQUEST,
  CIR_SAVE_SUCCESS,
  CIR_SAVE_FAILURE,
  HEALTH_TYPES_REQUEST,
  HEALTH_TYPES_SUCCESS,
  HEALTH_TYPES_FAILURE,
  PATIENT_HEALTH_TYPES_REQUEST,
  PATIENT_HEALTH_TYPES_SUCCESS,
  PATIENT_HEALTH_TYPES_FAILURE,
  REPORT_UPLOAD_FILES_REQUEST,
  REPORT_UPLOAD_FILES_SUCCESS,
  REPORT_UPLOAD_FILES_FAILURE,
  
} from './ClinicalIncidentActions';

const initialState = {
  data: [],
  report: {},
  error: null,
  isCIRLoading: false,
  lookups: [],
  isLookupsLoading: false,
  uploads: {},
  isFilesUploading: false,
  types: null,
  childTypes: null,
  isTypesLoading: false,
};

export default function clinicalIncidentReducer(
  state = initialState,
  { type, payload },
) {
  switch (type) {
    case ALL_CIR_REQUEST:
      return { ...state, isCIRLoading: true };
    case ALL_CIR_SUCCESS:
      return {
        ...state,
        data: payload.data,
        report: {},
        error: null,
        isCIRLoading: false,
      };
    case ALL_CIR_FAILURE:
      return { ...state, error: payload.error, isCIRLoading: false };

    case ALL_CIR_LOOKUPS_REQUEST:
      return { ...state, isLookupsLoading: true };
    case ALL_CIR_LOOKUPS_SUCCESS:
      return {
        ...state,
        lookups: payload.data,
        error: null,
        isLookupsLoading: false,
      };
    case ALL_CIR_LOOKUPS_FAILURE:
      return { ...state, error: payload.error, isLookupsLoading: false };

    case CIR_REQUEST:
      return { ...state, isCIRLoading: true };
    case CIR_SUCCESS:
      return { ...state, report: payload.data, errors: null, isCIRLoading: false };
    case CIR_FAILURE:
      return { ...state, error: payload.error, isCIRLoading: false };

    case CIR_SAVE_REQUEST:
      return { ...state, isCIRLoading: true };
    case CIR_SAVE_SUCCESS:
      return { ...state, report: payload.data, errors: null, isCIRLoading: false };
    case CIR_SAVE_FAILURE:
      return { ...state, error: payload.error, isCIRLoading: false };

    case REPORT_UPLOAD_FILES_REQUEST:
      return { ...state, uploads: {}, isFilesUploading: true };
    case REPORT_UPLOAD_FILES_SUCCESS:
      return {
        ...state,
        uploads: payload.data,
        errors: null,
        isFilesUploading: false,
      };
    case REPORT_UPLOAD_FILES_FAILURE:
      return {
        ...state,
        error: payload.error,
        isFilesUploading: false,
      };

    case HEALTH_TYPES_REQUEST:
      return { ...state, isTypesLoading: true };
    case HEALTH_TYPES_SUCCESS:
      return {
        ...state,
        types: payload.data,
        error: null,
        isTypesLoading: false,
      };
    case HEALTH_TYPES_FAILURE:
      return { ...state, error: payload.error, isTypesLoading: false };

    case PATIENT_HEALTH_TYPES_REQUEST:
      return { ...state, isTypesLoading: true };
    case PATIENT_HEALTH_TYPES_SUCCESS:
      return {
        ...state,
        childTypes: payload.data,
        error: null,
        isTypesLoading: false,
      };
    case PATIENT_HEALTH_TYPES_FAILURE:
      return { ...state, error: payload.error, isTypesLoading: false };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/cir-manager/ClinicalIncidentReducer.js